module.exports = __webpack_public_path__ + "img/result-tobe.53bcf902.svg";